
import { defineComponent } from 'vue'
import * as HIcons from '@heroicons/vue/outline'
export default defineComponent({
  name: 'HeroIcon',
  props: {
    name: String,
    size: { type: String, default: 'default' },
    color: { type: String }
  },
  data () {
    return {
      HIcons: HIcons,
      isLoaded: false
    }
  },
  setup (props : any) : any {
    let convertedName = props.name.split('-').map(function (c : string) { return c[0].toUpperCase() + c.slice(1) }).join('')
    if (!convertedName.endsWith('Icon')) {
      convertedName += 'Icon'
    }
    return {
      convertedName
    }
  },
  created () : void {
    this.isLoaded = true
  }
})
